/*
  Copyright (c) Epic Games, Inc. All Rights Reserved.
  CONTAINS AI GENERATED CODE.
*/

import { QuoteSectionFragment } from "@cosmos/hygraph-schema";
import {
	BackgroundContainer,
	Quote,
	ResponsiveContainer,
	SectionContainer,
	SectionHeading,
} from "@components/elements";
import { VStack } from "@panda/jsx";
import { css, cx } from "@panda/css";

export const QuoteSection = ({ config, quotes }: QuoteSectionFragment): React.JSX.Element | null => {
	const validHeading = Boolean(config?.heading?.title || config?.heading?.desc);
	const validContent = Boolean(quotes?.length);
	if (!validHeading && !validContent) return null;
	return (
		<BackgroundContainer
			bgAnimation={config?.backgroundAnimation}
			bgImageAsset={config?.backgroundImage}
			bgFullHeight={config?.backgroundFullHeight}
			edsBackgroundColor={config?.edsBackgroundColor}
		>
			<ResponsiveContainer>
				<SectionContainer>
					<VStack
						alignItems="stretch"
						gap="eds.dimension.96"
						className={cx(
							"quote-section",
							css({
								mdDown: {
									gap: "eds.dimension.80",
								},
							}),
						)}
					>
						{validHeading ? <SectionHeading {...config?.heading} /> : null}
						{validContent ? quotes?.map((quote, i) => <Quote key={`quote-${i}`} {...quote} />) : null}
					</VStack>
				</SectionContainer>
			</ResponsiveContainer>
		</BackgroundContainer>
	);
};
